import type { WorkflowStateEnum, WorkflowTypeEnum } from '@omnea-app/packages/universal/workflow/workflowEnums'

type ListWorkflowsParams = {
  includeArchived?: boolean
  state?: unknown[]
  workflowType?: unknown
  workflowTypes?: unknown[]
  excludeHiddenFromRequestors?: boolean
}

type ListWorkflowsForRequestCreationParams = {
  state: WorkflowStateEnum[]
  workflowTypes: WorkflowTypeEnum[]
}

export const workflowQueryKeys = {
  all: ['workflows'] as const,
  lists: () => [...workflowQueryKeys.all, 'list'] as const,
  list: (params: ListWorkflowsParams) => [...workflowQueryKeys.lists(), params] as const,
  forRequestCreation: (params: ListWorkflowsForRequestCreationParams) =>
    [...workflowQueryKeys.lists(), 'for-request-creation', params] as const,
  details: () => [...workflowQueryKeys.all, 'detail'] as const,
  detail: (workflowId: string) => [...workflowQueryKeys.details(), workflowId] as const,
  conditionGroups: (workflowId: string, draftId?: string) =>
    [...workflowQueryKeys.detail(workflowId), 'condition-groups', draftId] as const,
  draft: (workflowId: string, draftId: string) => [...workflowQueryKeys.detail(workflowId), 'draft', draftId] as const,
  pendingScheduledRequests: (workflowId: string) =>
    [...workflowQueryKeys.detail(workflowId), 'pending-scheduled-requests'] as const,
  events: (workflowId: string) => [...workflowQueryKeys.detail(workflowId), 'events'] as const,
  configReview: (workflowId: string) => [...workflowQueryKeys.detail(workflowId), 'config-review'] as const,
  draftEvents: (workflowId: string, draftId: string) =>
    [...workflowQueryKeys.detail(workflowId), 'drafts', draftId, 'events'] as const,
}
